import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GoalActivityLogged from './icon-goal-activity-logged.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GoalActivityLogged {...validProps} />;
}
SvgComponent.iconName = 'goal-activity-logged';

/**
 * @deprecated This is a legacy icon
 */
export const GoalActivityLoggedIcon = svgIconWrapper(SvgComponent);
